// extracted by mini-css-extract-plugin
module.exports = {"lds-default":"loader_lds-default__4h8AS","center":"loader_center__Zcsg1"};